export class Reporter {
	// This type is fine
	// eslint-disable-next-line @typescript-eslint/ban-types
	constructor(private readonly fn: Function) {
		// Empty
	}

	public log(message: string): void {
		this.fn(message);
	}
}
